import { render, staticRenderFns } from "./dialogsContact.vue?vue&type=template&id=c31e3090"
import script from "./dialogsContact.vue?vue&type=script&lang=js"
export * from "./dialogsContact.vue?vue&type=script&lang=js"
import style0 from "./dialogsContact.vue?vue&type=style&index=0&id=c31e3090&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports